/**
 * "Ground the agent in your analytics" — Guides section (IMP-10 / ADR-0238).
 * The vetted BYOMCP recipe for feeding behavioral/journey context to the agent
 * from the customer's OWN analytics stack (PostHog / Amplitude MCP), riding the
 * existing BYOMCP machinery — confirm-gate, read-only scopes, pinned egress. No
 * native capture (ADR-0238). Links to the canonical MCP + BYOMCP pages.
 */
import type { DocPageContent } from '../types';

export const GUIDES_ANALYTICS_GROUNDING_PAGE: DocPageContent = {
  slug: 'guides/analytics-grounding',
  titleKey: 'docs.guides.analytics.title',
  descriptionKey: 'docs.guides.analytics.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.analytics.lead' },

    { kind: 'heading', level: 2, id: 'why', textKey: 'docs.guides.analytics.why.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.analytics.why.body' },

    { kind: 'heading', level: 2, id: 'steps', textKey: 'docs.guides.analytics.steps.heading' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.guides.analytics.step.register.title',
          textKey: 'docs.guides.analytics.step.register.text',
        },
        {
          titleKey: 'docs.guides.analytics.step.scopes.title',
          textKey: 'docs.guides.analytics.step.scopes.text',
        },
        {
          titleKey: 'docs.guides.analytics.step.verify.title',
          textKey: 'docs.guides.analytics.step.verify.text',
        },
        {
          titleKey: 'docs.guides.analytics.step.ask.title',
          textKey: 'docs.guides.analytics.step.ask.text',
        },
      ],
    },

    {
      kind: 'callout',
      tone: 'caution',
      titleKey: 'docs.guides.analytics.readonly.title',
      textKey: 'docs.guides.analytics.readonly.body',
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.guides.analytics.privacy.title',
      textKey: 'docs.guides.analytics.privacy.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.mcp.related.connect.title',
          textKey: 'docs.guides.mcp.related.connect.text',
          to: { docSlug: 'mcp/connect' },
        },
        {
          titleKey: 'docs.guides.mcp.related.tools.title',
          textKey: 'docs.guides.mcp.related.tools.text',
          to: { docSlug: 'mcp/tools' },
        },
      ],
    },
  ],
};
